import React from 'react'
import { useFooter, FooterProps } from './useFooter'
import { Link } from 'react-router-dom'
import styles from './Footer.module.scss'
import logoImg from 'img/logo.webp'

const Footer: React.FC<FooterProps> = (props: FooterProps) => {
  const {} = useFooter(props)

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles['footer-top']}`}>
        <div className='row gy-4'>
          <div className={`col-lg-5 col-md-12 ${styles['footer-about']}`}>
            <a
              href='#hero'
              className={`${styles.logo} d-flex align-items-center`}
            >
              <img src={logoImg} alt='logo' height={80} />
            </a>
            <p>
              Say goodbye to outdated PDFs and hard-to-edit menus. Create a
              modern, mobile-friendly menu that looks amazing and updates
              instantly — no tech skills needed.
            </p>
            <div className={`${styles['social-links']} d-flex mt-4`}>
              <a
                href='https://www.instagram.com/bytebuffetbox/'
                target='_blank'
                rel='noreferrer'
              >
                <i className='bi bi-instagram'></i>
              </a>
              <a
                href='https://www.facebook.com/bytebuffetbox'
                target='_blank'
                rel='noreferrer'
              >
                <i className='bi bi-facebook'></i>
              </a>
              <a
                href='https://www.tiktok.com/@bytebuffetbox'
                target='_blank'
                rel='noreferrer'
              >
                <i className='bi bi-tiktok'></i>
              </a>
            </div>
          </div>

          <div className={`col-lg-2 col-6 ${styles['footer-links']}`}>
            <h4>Explore</h4>
            <ul>
              <li>
                <a href='#hero'>Home</a>
              </li>
              <li>
                <a href='#about'>About</a>
              </li>
              <li>
                <a href='#features'>Features</a>
              </li>
              <li>
                <a href='#how-it-works'>How It Works</a>
              </li>
              <li>
                <a href='#pricing'>Pricing</a>
              </li>
              <li>
                <a href='#faq'>FAQ</a>
              </li>
              <li>
                <a href='#contact'>Contact</a>
              </li>
            </ul>
          </div>

          <div className={`col-lg-2 col-6 ${styles['footer-links']}`}>
            <h4>Policies</h4>
            <ul>
              <li>
                <Link to='terms-and-conditions'>Terms & Conditions</Link>
              </li>
              <li>
                <Link to='privacy-policy'>Privacy Policy</Link>
              </li>
            </ul>
          </div>

          <div
            className={`col-lg-3 col-md-12 ${styles['footer-contact']} text-center text-md-start`}
          >
            <h4>Contact Us</h4>
            <p>Beirut, Lebanon</p>
            <p className='mt-4'>
              <strong>Phone:</strong>{' '}
              <a href='tel:+96176951367'>+961 76 951 367</a>
            </p>
            <p>
              <strong>Email:</strong>{' '}
              <a href='mailto:support@bytebuffetbox.com'>
                support@bytebuffetbox.com
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className={`container ${styles.copyright} text-center mt-4`}>
        <p>
          © <span>Copyright</span>{' '}
          <strong className={`px-1 ${styles.sitename}`}>ByteBuffetBox</strong>{' '}
          <span>All Rights Reserved</span>
        </p>
      </div>
    </footer>
  )
}

export default Footer
